import source from './brand/logo.svg?raw';
import { cn } from './cn';

// The studio's "main" mark, copied from the showcase site (backlog §16 P5g.2), drawn in `currentColor`.
const viewBox = /viewBox="([^"]+)"/.exec(source)![1]!;
const d = /<path d="([^"]+)"/.exec(source)![1]!;
const STUDIO = 'Obsession Studio';

/**
 * The studio's hand, `size` px square, in the text colour so it reads on light and dark surfaces alike. Named
 * "Obsession Studio" (or `title`) for assistive tech, unless `decorative` (a link or a heading already names it).
 */
export function Logo({ size, title, decorative, className }: { size: number; title?: string; decorative?: boolean; className?: string }) {
  return (
    <svg
      viewBox={viewBox}
      width={size}
      height={size}
      {...(decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': title ?? STUDIO })}
      className={cn('shrink-0', className)}
    >
      <path d={d} fill="currentColor" />
    </svg>
  );
}
